import { trackEvent } from "./analytics";

const CONVERSION_GOALS: Array<[RegExp, string]> = [
  [/^\/(?:register|signup)(?:\/|$)/, "registration"],
  [/^\/contact(?:\/|$)/, "contact"],
  [/^\/(?:products|catalog|drugs|ndc|therapeutic-classes)(?:\/|$)/, "catalog"],
];

export function insightConversionGoal(destinationPath: string): string {
  return CONVERSION_GOALS.find(([pattern]) => pattern.test(destinationPath))?.[1] ?? "other";
}

export function trackInsightInternalLink(
  storySlug: string,
  topicCluster: string | undefined,
  destinationPath: string,
): void {
  trackEvent("insight_internal_link_clicked", {
    story_slug: storySlug,
    topic_cluster: topicCluster || "unassigned",
    destination_path: destinationPath,
    conversion_goal: insightConversionGoal(destinationPath),
  });
}

export function trackPressPlacement(
  storySlug: string,
  topicCluster: string | undefined,
  publisher: string,
): void {
  trackEvent("press_placement_clicked", {
    story_slug: storySlug,
    topic_cluster: topicCluster || "unassigned",
    publisher,
  });
}